import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { dataMetaSelector } from "Bands/state";
import { deleteAccommodationReservation } from "Bands/state/data/actions/eventBlocks/eventAccommodationReservation";
import { BAND_ACTIONS, IAccommodationReservation } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import { copy } from "shared/assets";
import { DeleteModal } from "shared/components";
import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { useBandContext } from "Bands/contexts";
import { dispatchGetEventAccommodationRoomsForBlock } from "Bands/state/data/actions/eventBlocks/eventAccommodationRoom";
import { dispatchGetEventAccommodationRoomTypes } from "Bands/state/data/actions/eventBlocks/eventAccommodationRoomType";

const { accommodationBlock: blockCopy } = copy;

interface DeleteAccommodationReservationModalProps {
  accommodationReservation: IAccommodationReservation;
  blockId: string;
  handleClose: () => void;
}

export const DeleteAccommodationReservationModal: React.FC<DeleteAccommodationReservationModalProps> =
  ({ accommodationReservation: { id, bandUser }, blockId, handleClose }) => {
    const dispatch = useDispatch();
    const { findBandUser } = useBandContext();

    const { api: apiMeta } = useSelector(
      dataMetaSelector(BAND_ACTIONS.deleteAccommodationReservation)
    );

    useClearActionMetaOnUnMount(BAND_ACTIONS.deleteAccommodationReservation);

    useEffect(() => {
      if (apiMeta?.status === IAPIState.succeeded) {
        handleClose();

        dispatch(
          addTemporaryToast({
            status: IStatus.success,
            message: blockCopy.create.peopleBlock.messages.delete,
          })
        );

        dispatchGetEventAccommodationRoomTypes(dispatch, blockId);
        dispatchGetEventAccommodationRoomsForBlock(dispatch, blockId);
      }
    }, [apiMeta?.status, blockId, dispatch, handleClose]);

    const handleDelete = () => {
      dispatch(deleteAccommodationReservation({ id, blockId }));
    };

    const error = useMemo(() => !!apiMeta?.error, [apiMeta?.error]);

    return (
      <DeleteModal
        name={findBandUser(bandUser.id)?.firstname || "type_reservation"}
        type="reservation for"
        dataTestId="accommodation_reservation_delete_modal"
        apiMeta={apiMeta}
        handleClose={handleClose}
        handleDelete={handleDelete}
        error={error}
      />
    );
  };
